import stagingConfig from './config.staging';
import productionConfig from './config.production';

export const getConfig = () =>
  process.env.REACT_APP_ENV !== 'production' ? stagingConfig : productionConfig;

export const getEnviroment = () => process.env.REACT_APP_ENV;
